/* Customer-care pages (page.terms): the side menu swaps only the page content instead of reloading the
 * whole page. Each page keeps its own URL (pushState), back/forward work, and anything unexpected falls
 * back to a normal page load. Pages are prefetched on hover, so the swap is near-instant. */
(() => {
  const T = window.Theme || {};
  const section = () => document.querySelector('.terms-page')?.closest('.shopify-section');
  if (!section()) return;
  const cache = new Map();
  const get = (url) => {
    if (!cache.has(url)) {
      cache.set(url, fetch(url, { credentials: 'same-origin' }).then((r) => (r.ok ? r.text() : Promise.reject(r.status))));
      cache.get(url).catch(() => cache.delete(url));
    }
    return cache.get(url);
  };
  const isNavLink = (a) => a && a.matches('.terms-page__link') && a.origin === location.origin;
  history.replaceState({ ...(history.state || {}), terms: true }, '');

  /* Accordions and the mobile "all pages" menu live here (not inline in the section) so they keep
   * working after a soft swap: scripts inside swapped-in HTML never run. */
  const collapseNav = () => {
    const d = document.querySelector('[data-terms-nav]');
    if (d && !matchMedia('(min-width: 990px)').matches) d.open = false;
  };
  collapseNav();
  document.addEventListener('click', (e) => {
    const b = e.target.closest('.terms-page button.accordion');
    if (!b) return;
    const panel = b.nextElementSibling;
    const open = b.getAttribute('aria-expanded') !== 'true';
    b.setAttribute('aria-expanded', String(open));
    b.classList.toggle('active', open);
    if (window.Theme?.slide) window.Theme.slide(panel, open, { hidden: 'until-found' });
    else if (open) panel.removeAttribute('hidden'); else panel.setAttribute('hidden', 'until-found');
  });
  document.addEventListener('beforematch', (e) => {
    const b = e.target.previousElementSibling;
    if (b?.matches('.terms-page button.accordion')) { b.setAttribute('aria-expanded', 'true'); b.classList.add('active'); }
  }, true);

  const load = async (url, push) => {
    const current = section();
    current.setAttribute('aria-busy', 'true');
    current.classList.add('is-swapping');
    try {
      const doc = new DOMParser().parseFromString(await get(url), 'text/html');
      const next = doc.querySelector('.terms-page')?.closest('.shopify-section');
      if (!next) throw new Error('different template');
      const fresh = document.importNode(next, true);
      fresh.classList.add('is-entering');
      current.replaceWith(fresh);
      collapseNav();
      document.title = doc.title;
      if (push) history.pushState({ terms: true }, '', url);
      /* keep the reader at the top of the new content (not the top of the page) */
      const content = fresh.querySelector('.terms-page__content');
      const offset = (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-h')) || 64) + 16;
      if (content && content.getBoundingClientRect().top < offset) {
        scrollTo({ top: content.getBoundingClientRect().top + scrollY - offset, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
      fresh.querySelector('h1')?.setAttribute('tabindex', '-1');
      fresh.querySelector('h1')?.focus({ preventScroll: true });
      requestAnimationFrame(() => fresh.classList.remove('is-entering'));
      T.reveal?.(fresh);
      T.cookieDeclaration?.(fresh);
      /* analytics: soft navigations don't reload GTM, so tell it about the new page */
      (window.dataLayer = window.dataLayer || []).push({ event: 'virtual_page_view', page_path: new URL(url).pathname, page_title: doc.title });
    } catch (e) {
      location.href = url;
    }
  };

  document.addEventListener('click', (e) => {
    const a = e.target.closest('a');
    if (!isNavLink(a) || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    if (a.href !== location.href) load(a.href, true);
  });
  document.addEventListener('pointerover', (e) => {
    const a = e.target.closest?.('a');
    if (isNavLink(a) && a.href !== location.href) get(a.href).catch(() => {});
  });
  addEventListener('popstate', (e) => { if (e.state?.terms && section()) load(location.href, false); });
})();
